import React, { useMemo } from 'react';

import { Button, SxProps } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { RiFileExcel2Fill } from 'react-icons/ri';

import { useRequestListagem } from 'hooks/useRequestListagem';

type DownloadModeloArquivoBtn = {
    dsChave: string;
    text?: string;
    sx?: SxProps;
};

function useQueryModeloArquivo({ dsChave }: { dsChave: string }) {
    const requestListagem = useRequestListagem();

    return useQuery<string>({
        queryKey: ['modelo-arquivo', dsChave],
        queryFn: () =>
            requestListagem({
                url: '/config/configgeral/chave',
                extraParams: [{ dsChave }],
            }).then((res) => `${res.data}?t=${Date.now()}`),
    });
}

export function DownloadModeloArquivoBtn({ dsChave, sx, text = 'Download do modelo do arquivo' }: DownloadModeloArquivoBtn) {
    const { data } = useQueryModeloArquivo({ dsChave });

    return (
        <Button href={data} variant="outlined" color="success" hidden={Boolean(!data)} startIcon={<RiFileExcel2Fill />} sx={sx}>
            {text}
        </Button>
    );
}
